export default {
  qInfo: { qType: 'visualization' },
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['domain_code'],
          qFieldLabels: ['domainCode'],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['domain'],
          qFieldLabels: ['domain'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['metric_code'],
          qFieldLabels: ['metricCode'],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['metric_label'],
          qFieldLabels: ['metricText'],
        },
        qNullSuppression: true,
      },
    ],
    qMeasures: [
      {
        qDef: {
          qDef: `Sum({<[year_academic] = {'$(v_cy)'}, [flag_has_data]={1}, [flag_leadingindicator]={0}>} 1)`,
          qLabel: 'Flag_CY',
        },
      },
    ],
    qInitialDataFetch: [{ qWidth: 5, qHeight: 2000 }],
  },
}
